import { Button, MenuItem, Stack, TextField } from '@mui/material';
import { Region } from '@src/constants/Regions';

interface Props {
  regions: {
    name: string;
    code: string;
  }[];
  setRegionCode(value: string): void;
  regionCode: string | null;
  searchQuery: string;
  setSearchQuery(value: string): void;
  onSearch(): void;
  isActive: boolean;
  setStatus(value: boolean): void;
  onClearFilters(): void;
}

function SearchContainer({
  regions,
  setRegionCode,
  regionCode,
  searchQuery,
  isActive,
  setStatus,
  setSearchQuery,
  onSearch,
  onClearFilters,
}: Props) {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter') {
      onSearch();
    }
  };

  return (
    <Stack direction="row" gap={0.75} mb={2}>
      <TextField
        select
        label="Status"
        value={isActive ? 'Active' : 'Inactive'}
        onChange={(e) => {
          setStatus(e.target.value === 'Active');
        }}
        size="small"
        sx={{
          width: '292px',
        }}>
        <MenuItem value="Active">Active</MenuItem>
        <MenuItem value="Inactive">Inactive</MenuItem>
      </TextField>
      <TextField
        select
        label="Region"
        value={regionCode ?? ''}
        onChange={(e) => setRegionCode(e.target.value as Region)}
        size="small"
        sx={{
          width: '292px',
        }}>
        {regions.map((region, index) => (
          <MenuItem key={index} value={region.code}>
            {region.name}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        placeholder="Search name"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        onKeyDown={handleKeyDown}
        variant="outlined"
        inputProps={{ autoComplete: 'off' }}
        size="small"
        sx={{
          width: '292px',
        }}
      />
      <Button
        variant="contained"
        color="primary"
        size="medium"
        onClick={onSearch}>
        Search
      </Button>
      <Button
        variant="outlined"
        color="primary"
        size="medium"
        onClick={onClearFilters}>
        Clear Filters
      </Button>
    </Stack>
  );
}

export default SearchContainer;
